<template>
  <v-select
    hide-details="auto"
    :items="chequeFor"
    v-model="filterDatas.cheqFor"
    item-text="name"
    item-value="id"
    label="Cheque For"
    outlined
    clearable
    dense
    @change="emitInput(filterDatas.cheqFor)"
  ></v-select>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    chequeFor: [
      {
        id: 'purchase',
        name: 'purchase',
      },
      {
        id: 'sale',
        name: 'sale',
      },
      {
        id: 'other',
        name: 'other',
      },
    ],
    selectChequeFor: null,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  methods: {
    emitInput(data) {
      this.$store.commit('UPDATE_CHEQUE_FOR_FILTER', data);

      this.$emit('input', this.filterDatas.cheqFor);
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectChequeFor = null;
      },
      deep: true,
    },
  },
  created() {
    this.$emit('input', this.filterDatas.cheqFor);
  },
};
</script>
